import React from 'react'
import './announcement-modal.styles.scss'
import Modal from '../modal/modal.component'
import alertIcon from '@/assets/danger.png';

const AnnouncementModal = ({
    show,
    cancel
}) => {
    return (
        <div className='announcement-modal'>
            <Modal
                show={show}
                cancel={cancel}
                text='Maintenance Scheduled for 4/29 and 4/30'
                cls='announcement' >
                <div className='announcement-modal__content'>
                    <div className='announcement-modal__text'>
                        <div>
                            <img 
                                src={alertIcon} 
                                alt='Announcement' 
                                className='announcement-modal__image' />
                        </div>
                        <div>
                            <p>We will be performing maintenance on our systems on <b>April 29th and 30th</b>. 
                                During this time, the platform will NOT be available.</p>
                            <p>We apologize for any inconvenience this may cause and 
                                appreciate your understanding.</p>
                        </div>
                    </div>
                    <hr />
                    {/* <div className="g-space-1"></div> */}
                    <div className='buttons'>
                        <button 
                            className='g-button' onClick={cancel}>
                            OK
                        </button>
                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default AnnouncementModal